import(/* webpackMode: "eager" */ "/app/node_modules/next-runtime-env/build/provider/env-provider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next-runtime-env/build/provider/use-env-context.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"display\":\"swap\",\"preload\":true,\"src\":[{\"path\":\"../constants/fonts/VVCentra2-Book.woff2\",\"style\":\"normal\",\"weight\":\"400\"},{\"path\":\"../constants/fonts/VVCentra2-Bold.woff2\",\"style\":\"normal\",\"weight\":\"700\"},{\"path\":\"../constants/fonts/VVCentra2-Medium.woff2\",\"style\":\"normal\",\"weight\":\"500\"}],\"variable\":\"--vv-centra-font\"}],\"variableName\":\"fonts\"}");
;
import(/* webpackMode: "eager" */ "/app/src/_styles/main.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ReCaptcha/ReCaptchaWrapper.tsx");
